import React, { Component } from "react";

class Loader extends Component {

    renderLoader() {
        return (
            <span className="custom-loader"></span>
        )
    }

    render() {
        return (
            <>
                <div className="bahag-error-modal-backdrop"></div>
                <div className="bahag-loader-container">
                    {this.renderLoader()}
                </div>
            </>
        );
    }
}

export default Loader;